export const LightAndWonderIntegrationDI = {
    MessageChannel: Symbol('MessageChannel'),
    ErrorsHandler: Symbol('ErrorsHandler'),
    APIAdapter: Symbol('APIAdapter')
};
